import { render, staticRenderFns } from "./ContenidoAlumno.vue?vue&type=template&id=6b748c98&"
import script from "./ContenidoAlumno.vue?vue&type=script&lang=js&"
export * from "./ContenidoAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports